import { useNavigate } from 'react-router-dom';
import style from './index.module.less';

interface CustomErrorProps {
    /** 错误提示文案 */
    error?: string;
}

export default function CustomError({ error = '当前页面服务存在错误' }: CustomErrorProps) {
    const navigate = useNavigate();

    const handleBackHome = () => {
        navigate('/workbench');
    };

    return (
        <div className={style.error}>
            <div className={style.errorContent}>
                <div className={style.errorMessage}>{error}</div>
                <button className={style.backButton} onClick={handleBackHome}>
                    回到主页
                </button>
            </div>
        </div>
    );
}
